import { Pipe, PipeTransform } from '@angular/core';
import { Department } from './api-interfaces';

@Pipe({
  name: 'department'
})
export class DepartmentPipe implements PipeTransform {

  transform(deparments: Department[]): string {
    if (deparments.length <= 0) {
      return '';
    }
    return deparments.reduce((prev, curr, index, all) => {
      let dept =  prev + curr.department_name;
      // if (index < all.length - 1) {
      //   dept += ', ';
      // }
      return dept;
    }, '');

  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/department.pipe.ts